<template>
  <div class="feedback-success">
    <navbar title="意见反馈" left-text show-home></navbar>
    <img src="../assets/img/feedback-suc-tips.png" alt="">
    <p>感谢您的反馈，我们会尽快处理。</p>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
export default {
  name: 'feedbackSuccess',
  components: {
    Navbar
  }
}
</script>

<style lang="less" scoped>
.feedback-success {
  padding: 1.46rem 0;
  background-color: #fff;
  text-align: center;
  font-size: @fz32;
  color: @base;
  img {
    width: 1.34rem;
    padding-bottom: 0.6rem;
  }

}
</style>
